<div class="custella-modal">
        <div class="custella-modal-header align-items-center">
            <div class="custella-modal-header-text">Delete Organization Confirmation</div>
            <i class="pi pi-times" [pTooltip]="translate?.general?.buttons?.close.singular" tooltipPosition="left" (click)="modalRef.hide()"></i>
        </div>

        <div class="custella-form-container position-relative d-block w-100 rounded-2 m-0">
                <div class="custella-form-container-content m-0">
                    <div class="custella-content-row pe-0">
                        <div class="custella-content-row-input col-12">
                            <span class="text-12">This action will <strong>permanently delete</strong> your organization. All data including work orders, assets, team members, and reports will be <strong>permanently removed</strong> and <strong>cannot be recovered.</strong></span>
                            <span class="custella-content-row-input-title mt-3">To confirm deletion, type your organization name below:</span>
                           <input pInputText autocomplete="off" type="text" placeholder="Type organization name here" [(ngModel)]="deleteReason" (ngModelChange)="onOrgNameChange($event)"/>
                        </div>
                    </div>
                </div>

                <!-- Container Footer -->
            <div class="custella-form-container-footer mb-0">
                <div class="flex-align-center justify-content-end">
                    <button class="custella-btn-white text-12 ms-2" (click)="modalRef.hide()">{{translate?.general?.buttons?.cancel.singular}}</button>
                    <p-button label="Delete Organization" styleClass="ms-2 h-32" [disabled]="submitTouched" (onClick)="setDeleteSubscription()"></p-button> <!-- add ngClass="danger" when disabled = false -->
                </div>
            </div>
            
        </div>
</div>